import React, { Component } from 'react';
import './Account.css'
import AccountHeader from './AccountHeader';
import { Link, Redirect } from 'react-router-dom'
import {
    Card,
    Form,
    Input,
    Button,
    Row,
    Col,
    Alert,
    Space,
    Divider
} from 'antd';
import {
    LockOutlined,
    KeyOutlined,
    CheckCircleOutlined,
    EyeOutlined,
    EyeInvisibleOutlined
} from '@ant-design/icons';
import {
    post_data_token,
    LOGIN_CHANGE_PASSWORD,
} from '../../config/network.js'
import { showErrorMessage, ModalBox, openSuccessBox } from '../MessageBox';
import { FormattedMessage } from 'react-intl';

class ChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            redict: false,
        };
        this.formRef = React.createRef();
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit = (values) => {
        this.setState({ loading: true });

        const { oldPassword, newPassword, confirmPassword } = values;

        post_data_token(LOGIN_CHANGE_PASSWORD, {
            oldPsd: oldPassword,  // Send old password in plain text
            psd1: newPassword,    // Send new password in plain text  
            psd2: confirmPassword // Send confirm password in plain text
        })
            .then(data => {
                this.setState({ loading: false });
                openSuccessBox.call(this, { type: 'success', content: 'Password changed successfully!' });
                setTimeout(() => {
                    this.setState({ redict: true });
                }, 2000);
            })
            .catch(error => {
                this.setState({ loading: false });
                showErrorMessage.call(this, 'Change password error: ' + error);
            });
    }

    render() {
        if (this.state.redict) {
            return <Redirect to="/account/dashboard" />;
        }

        return (
            <div className="dashboard-container">
                <AccountHeader
                    page={"ChangePassword"}
                    title={<FormattedMessage id="page.sidnav.title.ChangePassword" defaultMessage="Change Password" />}
                />

                <div className="dashboard-content">
                    {/* Form Section */}
                    <Row gutter={[24, 24]} justify="center">
                        <Col xs={24} sm={20} md={16} lg={12} xl={10}>
                            <Card
                                title={
                                    <Space>
                                        <KeyOutlined />
                                        <span>Password Settings</span>
                                    </Space>
                                }
                                className="profile-card"
                            >
                                <Form
                                    ref={this.formRef}
                                    layout="vertical"
                                    onFinish={this.handleSubmit}
                                    autoComplete="off"
                                    size="large"
                                >
                                    <Form.Item
                                        name="oldPassword"
                                        label="Current Password"
                                        rules={[
                                            { required: true, message: 'Please input your current password!' }
                                        ]}
                                    >
                                        <Input.Password
                                            prefix={<LockOutlined />}
                                            placeholder="Enter your current password"
                                            iconRender={visible => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="newPassword"
                                        label="New Password"
                                        rules={[
                                            { required: true, message: 'Please input your new password!' },
                                            { min: 6, message: 'Password must be at least 6 characters long!' },
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (!value || getFieldValue('oldPassword') !== value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(new Error('New password must be different from current password!'));
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input.Password
                                            prefix={<KeyOutlined />}
                                            placeholder="Enter your new password"
                                            iconRender={visible => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="confirmPassword"
                                        label="Confirm New Password"
                                        dependencies={['newPassword']}
                                        rules={[
                                            { required: true, message: 'Please confirm your new password!' },
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (!value || getFieldValue('newPassword') === value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(new Error('The two passwords do not match!'));
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input.Password
                                            prefix={<CheckCircleOutlined />}
                                            placeholder="Confirm your new password"
                                            iconRender={visible => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
                                        />
                                    </Form.Item>

                                    <Divider />

                                    <Form.Item style={{ marginBottom: 0 }}>
                                        <Space style={{ width: '100%', justifyContent: 'space-between' }}>
                                            <Link to="/account/dashboard">
                                                <Button>
                                                    Cancel
                                                </Button>
                                            </Link>
                                            <Button
                                                type="primary"
                                                htmlType="submit"
                                                loading={this.state.loading}
                                                icon={<LockOutlined />}
                                            >
                                                Change Password
                                            </Button>
                                        </Space>
                                    </Form.Item>
                                </Form>

                                <Divider />

                                <Alert
                                    message="Password Security Tips"
                                    description={
                                        <ul style={{ marginBottom: 0, paddingLeft: '20px' }}>
                                            <li>Use at least 8 characters</li>
                                            <li>Include uppercase and lowercase letters</li>
                                            <li>Add numbers and special characters</li>
                                            <li>Avoid using personal information</li>
                                        </ul>
                                    }
                                    type="info"
                                    showIcon
                                />
                            </Card>
                        </Col>
                    </Row>
                </div>
                {ModalBox.call(this)}
            </div>
        );
    }
}

export default ChangePassword;
